import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  icon: {
    color: theme.palette.primary.main,
  },
}));
